import { useView } from '../../hooks';
import { useAppContext } from '../../shared';
import { formatDate } from '../../utilities';
import { Slug, Button } from '../../components';
import { Dropdown, Table } from '../../components';
import { Form, FormItem, TopPanel } from '../../components';
import { useCampaignMonitoring } from './useCampaignMonitoring';

const getColor = (status: string | null): SlugColorType => {
  switch (status) {
    case 'active':
      return 'main';
    default:
      return 'danger';
  }
};

const CampaignMonitoring = () => {
  const { meta } = useAppContext();
  const {
    nodes,
    refresh,
    filters,
    setFilters,
    metrics,
    reloading,
    intializing: loading,
  } = useCampaignMonitoring();
  const { element, handleView } = useView();

  return (
    <div className="flex flex-col gap-y-md w-full">
      {element}
      <TopPanel>
        <div className="mr-auto flex items-center gap-x-md min-w-[20rem]">
          Human Appointments Booked:
          <Slug text={metrics?.appointments_booked || 0} className="w-[3rem]" />
        </div>
        <Form<NonNullable<typeof filters>>
          initialValue={filters}
          onChange={setFilters}
        >
          <FormItem<NonNullable<typeof filters>> name="campaignId" label="">
            <Dropdown
              placeholder="Campaign"
              grow={false}
              options={[
                { value: '', label: 'All Campaigns' },
                ...meta.campaigns,
              ]}
            />
          </FormItem>
        </Form>
        <Button icon="refresh" loading={reloading} onClick={refresh}>
          Refresh
        </Button>
      </TopPanel>
      <div className="flex-1 overflow-y-auto">
        <Table
          data={nodes}
          loading={loading}
          config={{
            columns: [
              {
                header: 'Contact',
                cellClassName: 'text-small min-w-[20rem]',
                getValue: ({ contact_name, contact_email, contact_phone }) => (
                  <div>
                    <div>{contact_name}</div>
                    <div className="text-tiny text-textLight">
                      {contact_email}
                    </div>
                    <div className="text-tiny text-textLight">
                      {contact_phone}
                    </div>
                  </div>
                ),
              },
              {
                header: 'State',
                cellClassName: 'max-w-[15rem]',
                getValue: ({ latest_contact_state }) => (
                  <Slug
                    text={latest_contact_state || 'No State'}
                    color={getColor(latest_contact_state)}
                    className="max-w-[13rem]"
                  />
                ),
              },
              {
                header: 'Next Task Channel',
                cellClassName: 'text-tiny',
                getValue: ({ next_task_channel }) => next_task_channel,
              },
              {
                header: 'Campaign',
                cellClassName: 'text-small',
                getValue: ({ campaign_name }) => <Slug text={campaign_name} />,
              },
              {
                header: 'Next Task Time',
                cellClassName: 'text-tiny',
                getValue: ({ next_task_time }) => formatDate(next_task_time),
              },
              {
                header: 'Actions',
                align: 'right',
                cellClassName: 'min-w-[20rem]',
                getValue: item => (
                  <Button
                    icon="question"
                    width="small"
                    label="Task Details"
                    onClick={() => handleView(item)}
                  />
                ),
              },
            ],
          }}
        />
      </div>
    </div>
  );
};

export default CampaignMonitoring;
